import React from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import { Client } from 'api';
import Tracker from 'tracker';
import { SelectField, TextField } from 'components/forms';

const REASONS = [
    'Out of budget',
    'Not my style',
    'Not the right location',
    'Already contacted this vendor',
    'Already selected another vendor',
    'Other',
];

const VENUE_REASONS = [
    'Out of budget',
    'Not my style',
    'Not the right layout',
    'Not the right location',
    'Already contacted this vendor',
    'Already selected another vendor',
    'Other',
];

export default class extends React.Component {
    constructor(props) {
        super(props);

        this.toggleModal = this.toggleModal.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleReasonChanged = this.handleReasonChanged.bind(this);
        this.handleOtherReasonChanged = this.handleOtherReasonChanged.bind(this);

        this.api = new Client();
        this.tracker = new Tracker();

        this.state = {
            modalOpen: false,
            saving: false,
            showOther: false,
            reason: REASONS[0],
            otherReason: '',
        };
    }

    componentWillUnmount() {
        this.api.clear();
    }

    getVendorType() {
        if (this.props.vendor.type === 'other') {
            return 'vendor';
        }

        return this.props.vendor.type;
    }

    toggleModal() {
        this.setState({ modalOpen: !this.state.modalOpen });
    }

    handleReasonChanged(option) {
        this.setState({ reason: option.value });
    }

    handleOtherReasonChanged(value) {
        this.setState({ otherReason: value });
    }

    handleSubmit(e) {
        e.preventDefault();

        const reason = this.state.reason === 'Other' ? this.state.otherReason : this.state.reason;

        this.setState({ saving: true });
        this.api.request(`/api/events/${this.props.event.id}/leads/${this.props.lead.id}/reject`, {
            method: 'POST',
            data: {
                reason: reason,
            },
            success: (response) => {
                this.props.onRejected(response);
            },
        });
    }

    render() {
        return (
            <button className="btn btn-link" type="button" onClick={this.toggleModal}>
                Not interested in this {this.getVendorType()}?

                <Modal show={this.state.modalOpen} onHide={this.toggleModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            Please take a moment to let this {this.getVendorType()} know why you're passing on it.
                        </Modal.Title>
                    </Modal.Header>

                    <div className="modal-body">
                        <SelectField
                            name="reason"
                            label="Reason"
                            width="style"
                            value={this.state.reason}
                            onChange={this.handleReasonChanged}
                            options={(this.props.vendor.type === 'venue' ? VENUE_REASONS : REASONS).map(reason => {
                                const reasonText = reason.replace('vendor', this.getVendorType());

                                return { label: reasonText, value: reasonText };
                            })}
                        />

                        {this.state.reason === 'Other' && <TextField
                            name="other_reason"
                            label="Please specify (optional)"
                            value={this.state.otherReason}
                            onChange={this.handleOtherReasonChanged}
                        />}
                    </div>

                    <div className="modal-footer">
                        <button type="button" className="btn btn-dark" onClick={this.handleSubmit} disabled={this.state.saving}>
                            Submit
                        </button>
                    </div>
                </Modal>
            </button>
        );
    }
}



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/events/rejectVendor.jsx